import { render, staticRenderFns } from "./_OverviewTotalPrice.vue?vue&type=template&id=abbccdf2"
import script from "./_OverviewTotalPrice.vue?vue&type=script&lang=js"
export * from "./_OverviewTotalPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports